// Miraveila Product Page — sticky bar + gallery + buy pill + ZIP checker

(function () {
  'use strict';

  // ── Gallery ──────────────────────────────────────────────────────────────
  function initGallery() {
    var mainImg = document.getElementById('mv-main-img');
    var thumbs  = document.querySelectorAll('.mv-gallery__thumb');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.img;
        if (src) mainImg.src = src;
        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  // ── Buy pill: quantity + AJAX cart add ────────────────────────────────────
  function initBuyPill() {
    var dec      = document.getElementById('mv-qty-dec');
    var inc      = document.getElementById('mv-qty-inc');
    var display  = document.getElementById('mv-qty-display');
    var hidden   = document.getElementById('mv-qty-hidden');
    var addBtn   = document.getElementById('mv-add-btn');
    var addLabel = document.getElementById('mv-add-label');
    var form     = document.querySelector('.mv-product-form');

    if (!dec || !inc || !addBtn || !form) return;

    var qty = 1;

    function setQty(n) {
      qty = Math.max(1, n);
      if (display) display.textContent = qty;
      if (hidden)  hidden.value = qty;
    }

    dec.addEventListener('click', function () { setQty(qty - 1); });
    inc.addEventListener('click', function () { setQty(qty + 1); });

    // Use click on the button directly — avoids Dawn's product-info.js submit interception
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var variantId = (form.querySelector('[name="id"]') || {}).value;
      if (!variantId) return;

      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty }),
      })
        .then(function (r) {
          if (!r.ok) {
            return r.text().then(function (t) { throw new Error(t); });
          }
          return r.json();
        })
        .then(function () {
          if (addLabel) addLabel.textContent = 'Added ✓';
          showToast('Added to bag');
          refreshCart();
          setTimeout(function () {
            if (addLabel) addLabel.textContent = 'Add to bag';
            addBtn.disabled = false;
          }, 2200);
        })
        .catch(function (err) {
          console.error('[mv] cart add failed:', err);
          addBtn.disabled = false;
        });
    });
  }

  // ── Cart count + shipping bar refresh ────────────────────────────────────
  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update header bubble count
        var count = cart.item_count;
        document.querySelectorAll('.cart-count-bubble [aria-hidden="true"]').forEach(function (el) {
          el.textContent = count;
        });
        if (count > 0) {
          document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
            el.removeAttribute('hidden');
          });
        }
        updateShippingBar(cart.total_price);
      })
      .catch(function (err) { console.error('[mv] cart refresh failed:', err); });
  }

  function updateShippingBar(totalPrice) {
    var fill      = document.getElementById('mv-ship-fill');
    var msg       = document.querySelector('.mv-shipping-bar__top span');
    var threshold = 5000; // $50.00 in cents

    if (fill) {
      var pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
      // Double rAF ensures the CSS transition is active before we change width
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fill.style.width = pct + '%';
        });
      });
    }

    if (msg) {
      if (totalPrice >= threshold) {
        msg.innerHTML = "You've cleared $50 — shipping's <strong style='color:#b67e53'>on us</strong> for this one.";
      } else {
        var remaining = ((threshold - totalPrice) / 100).toFixed(2);
        msg.innerHTML = "Add <strong style='color:#b67e53'>$" + remaining + "</strong> more for free shipping.";
      }
    }
  }

  // ── Toast notification ────────────────────────────────────────────────────
  function showToast(message) {
    var toast = document.getElementById('mv-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'mv-toast';
      toast.className = 'mv-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2000);
  }

  // ── Sticky Bar ────────────────────────────────────────────────────────────
  function initStickyBar() {
    var bar    = document.getElementById('mv-sticky-bar');
    var buybox = document.getElementById('mv-buybox');
    if (!bar || !buybox) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
        bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { rootMargin: '-64px 0px 0px 0px', threshold: 0 });
    observer.observe(buybox);

    var barBtn = document.getElementById('mv-bar-add-btn');
    if (barBtn) {
      barBtn.addEventListener('click', function () {
        var addBtn = document.getElementById('mv-add-btn');
        if (addBtn) addBtn.click();
      });
    }
  }

// ── ZIP Checker ───────────────────────────────────────────────────────────
function initZipChecker() {
  var input     = document.getElementById('mv-zip-input');
  var btn       = document.getElementById('mv-zip-btn');
  var errEl     = document.getElementById('mv-zip-error');
  var okEl      = document.getElementById('mv-zip-ok');
  var container = document.querySelector('.mv-ship-est__zip');
  if (!input || !btn) return;

  // Parse "2–4" / "2-4" / "6" into { min, max }
  function parseShippingRange(raw) {
    if (!raw) return { min: 2, max: 5 };
    var cleaned = raw.replace(/–|—/g, '-').trim();
    var parts = cleaned.split('-').map(function (n) { return parseInt(n, 10); });
    if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) return { min: parts[0], max: parts[1] };
    if (parts.length === 1 && !isNaN(parts[0])) return { min: parts[0], max: parts[0] };
    return { min: 2, max: 5 };
  }

  // Add N business days to a date, skipping Sat/Sun
  function addBusinessDays(startDate, numDays) {
    var result = new Date(startDate);
    var added = 0;
    while (added < numDays) {
      result.setDate(result.getDate() + 1);
      var dayOfWeek = result.getDay(); // 0 = Sun, 6 = Sat
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        added++;
      }
    }
    return result;
  }

  var range = parseShippingRange(container ? container.getAttribute('data-shipping-time') : null);

  function checkZip() {
    var zip = input.value.trim();
    if (/^\d{5}$/.test(zip)) {
      var spread = range.max - range.min;
      var days   = range.min + (spread > 0 ? (parseInt(zip[4], 10) % (spread + 1)) : 0);

      var months  = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var arrive  = addBusinessDays(new Date(), days);
      var dateStr = months[arrive.getMonth()] + ' ' + arrive.getDate();

      if (okEl) {
        okEl.innerHTML = '— arrives by <strong style="color:#2a1d14">' + dateStr + '</strong> to ' + zip;
        okEl.classList.add('is-visible');
      }
      if (errEl) errEl.classList.remove('is-visible');
      input.classList.remove('has-error');
    } else {
      if (errEl) errEl.classList.add('is-visible');
      if (okEl)  okEl.classList.remove('is-visible');
      input.classList.add('has-error');
    }
  }

  btn.addEventListener('click', checkZip);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); checkZip(); }
  });
}

  // ── Quick-add for related product cards ──────────────────────────────────
  window.mvQuickAdd = function (btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId || btn.disabled) return;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓';
        btn.classList.add('is-added');
        refreshCart();
        showToast('Added to bag');
        setTimeout(function () {
          btn.textContent = '+';
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () { btn.disabled = false; });
  };

  // ── Boot ──────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initBuyPill();
    initStickyBar();
    initZipChecker();
    refreshCart(); // populate shipping bar from live cart on load
  });
})();
